import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils.
import {
  isArrayWithContent,
  isNumber,
  toNumber,
  formatAsCurrency,
} from '../../../utils';

// Components.
import Label from './Label';
import Select from './Select';
import Input from './Input';

// Siblings.
import sanitize from './sanitize';
import './styles.css';

//------------------------------------------------------------------------------

class Field extends Component {
  constructor(props) {
    super(props);

    // Binding 'this' keyword.
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onFocusHandler = this.onFocusHandler.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);

    // Validate incoming props.
    const initialValue = sanitize(props.type, props.value);

    // Set initial state.
    this.state = {
      value: initialValue,
      focused: false,
    };
  }

  onChangeHandler(event) {
    const { id, type, pattern, onChange } = this.props;
    const { value } = event.target;
    let nextValue = '';
    if (pattern) {
      // Handle inputs that are type='text' yet number-like.
      if (value) {
        const n = toNumber(value);
        if (isNumber(n)) {
          nextValue = n;
        }
      }
    } else {
      nextValue = sanitize(type, value);
    }
    this.setState({ value: nextValue }, onChange(id, nextValue));
  }

  onFocusHandler() {
    this.setState({ focused: true });
  }

  onBlurHandler() {
    this.setState({ focused: false });
  }

  render() {
    // Destructuring props/state.
    const {
      className,
      id,
      label,
      pattern,
      maxLength,
      placeholder,
      options,
    } = this.props;
    const { value, focused } = this.state;

    // Determine if we have a value set for either of the 2 field types.
    const hasValue = value !== undefined && value !== '';
    const valued = hasValue || (hasValue && !!options);

    // Determine which field to render.
    const hasOptions = isArrayWithContent(options);

    // Prepare classNames.
    const classNameRoot = classNames('Field', className);
    const classNameLabel = classNames('Field__Label', {
      'Field__Label--focused': focused,
      'Field__Label--valued': valued,
    });

    // Restructuring props.
    let nextValue = value;
    if (pattern) {
      // Handle inputs that are type='text' yet number-like.
      nextValue =
        value !== '' && typeof value === 'number'
          ? formatAsCurrency(value) // <-- BAD, sad: no budget, no rewrite
          : '';
    }
    const sharedProps = {
      id,
      placeholder: placeholder || label,
      value: nextValue,
      onChange: this.onChangeHandler,
      onFocus: this.onFocusHandler,
      onBlur: this.onBlurHandler,
    };
    const inputProps = { pattern, maxLength, ...sharedProps };
    const selectProps = { options, ...sharedProps };

    // Default render.
    return (
      <div className={classNameRoot}>
        <Label htmlFor={id} className={classNameLabel}>
          {label}
        </Label>
        <div>
          {hasOptions ? <Select {...selectProps} /> : <Input {...inputProps} />}
        </div>
      </div>
    );
  }
}

Field.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['number', 'string']).isRequired,
  pattern: PropTypes.string,
  maxLength: PropTypes.number,
  placeholder: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      content: PropTypes.node,
    }),
  ),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
};

Field.defaultProps = {
  className: null,
  pattern: null,
  maxLength: null,
  placeholder: null,
  options: null,
  value: undefined,
  onChange: null,
};

export default Field;



// WEBPACK FOOTER //
// ./src/components/Form/Field/index.js